import { Tool } from './tool';

export class Brush extends Tool {
  private drawing = false;
  private mouseMoved = false;

  setColor(color: string): void {
    super.setColor(color);

    if (color.slice(-2) === 'ff') {
      this.mainCtx.globalCompositeOperation = 'source-over';
    } else {
      this.mainCtx.globalCompositeOperation = 'xor';
    }
  }

  onMouseDown(e: MouseEvent | TouchEvent): void {
    if (this.isLocked) {
      return;
    }
    const { x, y } = this.getMousePosition(e);
    this.drawing = true;
    this.mouseMoved = false;
    this.updateCtxStyle(this.mainCtx);
    // begin path for mousemove drawing
    this.mainCtx.beginPath();
    this.mainCtx.moveTo(x, y);
  }

  onMouseMove(e: MouseEvent | TouchEvent): void {
    if (!this.isLocked && this.drawing) {
      this.mouseMoved = true;
      const { x, y } = this.getMousePosition(e);
      this.mainCtx.lineTo(x, y);
      this.mainCtx.closePath();
      this.mainCtx.stroke();
      this.mainCtx.beginPath();
      this.mainCtx.moveTo(x, y);
    }
  }

  onMouseUp(e: MouseEvent | TouchEvent): void {
    if (!this.isLocked && this.drawing) {
      this.drawing = false;
      if (!this.mouseMoved) {
        this.drawDot(e);
      }
      this.updateState();
      this.mouseMoved = false;
    }
  }
  protected drawDot(e: MouseEvent | TouchEvent): void {
    const { x, y } = this.getMousePosition(e);
    this.mainCtx.arc(x, y, 1.25, 0, 2 * Math.PI);
    this.mainCtx.stroke();
  }
}
